/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/data-set.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { formatDateUTC_DEPRECATED } from 'utils/convertor';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import { getFieldChangeItems, getProcessedFieldChangeItems } from 'views/pages/admin/audit-log/service';

const DataSetRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        DataSetVisible: oldRecord?.Active,
        DataCutDate: oldRecord?.DataCutDate,
        Active: null,
        DatasetDate: null,
    };
    const refactoredNewRecord = {
        ...newRecord,
        DataSetVisible: newRecord.Active,
        DataCutDate: newRecord?.DataCutDate,
        Active: null,
        DatasetDate: null,
    };

    const associations: any = {
        Reports: {
            itemField: 'reports',
            name: 'Report',
            nameResolver: (report: any) =>
                report.reportDate ? formatDateUTC_DEPRECATED(report.reportDate, true, 'DD-MMM-YYYY') : ' ',
        },
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            associations,
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { DataSetRecordChangeGrid };
